export default "__VITE_ASSET__DE9XyHCR__"